<template>
	<div class="gameDetail" @mousewheel="getWheel">
		<div id='frameDiv' class="frameDiv" v-show='isGameIframeShow'></div>
		<!-- 蒙层 -->
		<div class='modalDiv' v-show='RanksDialog'></div>
		<div class="contain">
			<!-- 游戏详情banner  -->
			<div class="detail-banner">
				<el-image v-if="gameDetail.logo_detail3" v-show="isDetailBannerShow" :src="gameDetail.logo_detail3" class="banner-img"></el-image>
					<el-image v-else v-show="isDetailBannerShow" :src="require('@/assets/game/gameDetail-banner.jpg')" class="banner-img"></el-image>
					<div class="masking-black" v-if="gameDetail.logo_detail3"></div>
					<div class="banner-game-part">
						<div class="game-part-left">
							<img :src="gameDetail.logo" alt="" class="game-logo">
							<div class="left-detail">
								<h3>{{gameDetail.name}}</h3>
								<p>{{gameDetail.game_introduction1}}</p>
								<div class="tag-group">
									<span v-for="(item,index) in gameDetail.GameTags" :key="index">{{item.Name}}</span>
								</div>
							</div>
						</div>
						<!-- 登录时显示 -->
						
						<div class="right-btn-group">
							<button class="play-game" v-show="$utils.checkLogin()&&!isAgainBtnShow" @click="openCloudGame()">
								<img src="@/assets/game/miaowan1.png" alt="">
								<span>秒玩</span>	
							</button>
							<button class="again-game" @click="replayCloudGame()" v-show="$utils.checkLogin()&&isAgainBtnShow">
								<span>重连</span>
							</button>
							<button class="close-game" @click='closeCloudGame()' v-show="$utils.checkLogin()&&isAgainBtnShow">
								<span>注销</span>
							</button>
							<!-- 非登录时显示 -->
							<button class="play-game" v-if='!$utils.checkLogin()' @click="notLoginPlay(getGameId)">
								<img src="@/assets/game/miaowan1.png" alt="">
								<span>秒玩</span>	
							</button>
						</div>
					</div>
			</div>
			<div class="game-conetnt-bg">
			</div>
			<div class="game-nav-part">
				<span style="cursor: pointer;" class="jump-game" @click="JumpToGame">云游戏</span>
				<span style="color: #646464;margin:0 5px">></span>
				<span style="color: #646464;">{{gameDetail.name}}</span>
			</div>
			<div class="game-detail-content">
				<div class="content-left">
					<swiper class="detail-swiper" :options="swiperOption" ref="mySwiper" id="mySwiper">
						<!-- <swiper-slide  v-for="(item,index) in gameDetail.logo_detail2" :key="index" 
						:style='{"background-image":"url("+item.url+")"}'> -->
						<swiper-slide  v-for="(item,index) in gameDetail.logo_detail2" :key="index" >
							<!-- <video v-if="item.isVideo" :src="item.url" width="100%" height="100%" :id="'swiperVideo'+index" :ref="'swiperVideo'+index"  controls="controls" style="object-fit:fill" >
							</video> -->
							<video-player v-if="item.isVideo" class="video-player" :id="'swiperVideo'+index" :ref="'swiperVideo'+index" :playsinline="true" :options="item.playerOptions" @play="onPlayerPlay(index)" @pause="onPlayerPause(index)"></video-player>
							<div v-if="item.isVideo" class="play-big" :id="'swiperVideoPlayIcon'+index" @click="handleVideoplay(index)"></div>
							<img v-else :src="item.url" >
						</swiper-slide>
						<div class="swiper-button-prev" slot="button-prev">
							<img src="@/assets/gameDetail/arrow-left.png" alt="">
						</div>
						<div class="swiper-button-next" slot="button-next">
							<img src="@/assets/gameDetail/arrow-right.png" alt="">
						</div>
					</swiper>
					
					<swiper class="detail-swiper-thumbs" :options="swiperThumbsOption" ref="thumbsSwiper" id="thumbsSwiper" >
						<swiper-slide v-for="(item,index) in gameDetail.logo_detail2" :key="index" >
							<div :class="{'swiper-slide-thumb-active':swiperIndex==index}" @click="clickThumbs(index)">
								<div class="masking-swiper"></div>
								<img v-if="item.isVideo" src="@/assets/gameDetail/play-small.png"  class="play-small" alt="">
								<video v-if="item.isVideo" :src="item.url" width="100%" height="100%" style="object-fit:fill">
								</video>
								<img v-else :src="item.url" alt="">
							</div>
						</swiper-slide>
					</swiper>

				</div>
				<div class="content-right">
					<img :src="gameDetail.logo_detail" alt="" class="des-img">
					<div class="des-content">
						<h5>游戏介绍</h5>
						<p>{{gameDetail.game_introduction2}}</p>
						<!-- <button @click="isShowMore=!isShowMore">查看更多</button> -->
					</div>
				</div>

				<img src="@/assets/game/mini-active.png" class="mini-active" alt="" v-show="miniActiveShow" @click="handleMiniActive">
			</div>
		</div>
		
		<my-footer></my-footer>
		<!-- 新手礼包 -->
		<!-- <transition name="el-fade-in">
			<div class='el-loading-mask is-fullscreen ' style='background-color: rgba(0, 0, 0, 0.8);z-index: 9999;'
				v-show="NoviceGiftShow" >
				<div class="NoviceGift" style='display: none;'>
					<el-image class='lingqv' src='img/index/lingqvbtn.png' @click.stop='getXinshou'></el-image>
				</div>
				
			</div>
		</transition> -->
		
		<!-- 换区提醒dialog -->
		<el-dialog  :visible.sync="huanqvDialog"  width="528px"  :close-on-press-escape='false' :show-close='false' :lock-scroll='false'
			:close-on-click-modal='false' top='20vh' class='outGameShowDialog'>
			
			<div class="content">
				<el-row style='display: flex;'>
					<el-col :span='18' style='margin: 30px auto 0;display: flex;flex-direction: column;width: auto;'>
						<el-image :src="require('@/assets/game/qxpd.png')" style='width: 200px;height: 200px;vertical-align: middle;margin: 0 auto;'>
						</el-image>
						<div 
						style='margin: 20px auto 0;width: 400px;text-align: center;color: rgba(13,13,13,1);font-size: 24px;'>
							小主，你已在游戏中，请问是否更换选区，更换成功后原游戏将会下线，是否确认操作？
						</div>
					</el-col>
				</el-row>
				
				<el-row style='display: flex;margin-top: 30px;'>
					<el-col :span='20' style='margin: 20px auto;display: flex;justify-content: space-around; width: auto;'>
						<el-button round @click='huanqvDialog=false;' class='btnHover2'
						style='background:rgba(248,248,248,1);border-color: rgba(248,248,248,1);color: #000;width: 214px;padding: 27px 10px;font-size:22px;border-radius: 39px;'>
							取消
						</el-button>
						<el-button round @click='huanqvCommit' class='btnHover'
						style='background:rgba(249,221,74,1);border-color: rgba(249,221,74,1);color: #000;width: 214px;padding: 27px 10px;font-size:22px;border-radius: 39px;'>
							确定
						</el-button>
					</el-col>
				</el-row>
			</div>
		</el-dialog>

		<!-- 余额不足时提醒 -->
		<el-dialog  :visible.sync="notMoney"  width="528px"  :close-on-press-escape='false' :show-close='false' :lock-scroll='false'
			:close-on-click-modal='false' top='22vh' class='notmoneyDialog'>
			
			<div class="content">
				<el-row style='display: flex;'>
					<el-col :span='18' style='margin: 10px auto;display: flex;flex-direction: column;'>
						<el-image :src="require('@/assets/game/yuebuzhu@2x.png')" style='width: 200px;height: 200px;vertical-align: middle;margin: 0 auto;'>
						</el-image>
						<div 
						style='margin: 0 auto;height: 80px; text-align: center;color: rgba(13,13,13,1);font-size: 24px;'>
							小主，您的游戏时长不足啦，
							快去充值吧~
						</div>
					</el-col>
				</el-row>
				
				<el-row style='display: flex;margin-top: 30px;'>
					<el-col :span='20' style='margin: 10px auto;display: flex;justify-content: space-around;'>
						<el-button round @click='getProducts();notMoney = false; dialogShow = true;' class='btnHover'
						style='background:rgba(249,221,74,1);border-color: rgba(249,221,74,1);color: #000;
						width: 328px;height:78px;padding: 15px 10px;border-radius: 39px;font-size: 22px;'>
							立即充值
						</el-button>
					</el-col>
				</el-row>
			</div>
		</el-dialog>

		<!-- 已经在游戏状态内的提示/ -->
		<el-dialog :visible.sync="isPlayStatus"  width="528px"  :close-on-press-escape='false' :show-close='false' :lock-scroll='false'
			:close-on-click-modal='false' top='22vh' class='PlayStatusDialog'>
			<div class="content">
				<el-row style='display: flex;'>
					<el-col :span='18' style='margin: 10px auto;display: flex;flex-direction: column;'>
						<el-image :src="require('@/assets/game/pdwc@2x.png')" style='width: 200px;height: 200px;vertical-align: middle;margin: 0 auto;'>
						</el-image>
						<div 
						style='margin: 10px auto 0 auto;width: 300px;text-align: center;color: rgba(13,13,13,1);font-size: 20px;font-weight: 600;'>
							小主，你在该区已有游戏登录中，
						<br>
							请勿重复操作
						</div>
					</el-col>
				</el-row>
				
				<el-row style='display: flex;margin-top: 30px;'>
					<el-col :span='20' style='margin: 10px auto;display: flex;justify-content: space-around;'>
						<el-button round @click='isPlayStatus = false;' class='btnHover'
						style='background:rgba(249,221,74,1);border-color: rgba(249,221,74,1);color: #000;width: 290px;padding: 25px 0;border-radius: 30px;'>
							知道了
						</el-button>
					</el-col>
				</el-row>
			</div>
		</el-dialog>

		<!--  玩游戏时 如果有其他重连状态的提醒 -->
		<el-dialog :visible.sync="replayTipsShow"  width="528px"  :close-on-press-escape='false' :show-close='false' :lock-scroll='false'
			:close-on-click-modal='false' top='22vh' class='PlayStatusDialog'>
			<div class="content">
				<el-row style='display: flex;'>
					<el-col :span='24' style='margin: 10px auto;display: flex;flex-direction: column;'>
						<el-image :src="require('@/assets/game/pdwc@2x.png')" style='width: 200px;height: 200px;vertical-align: middle;margin: 0 auto;'>
						</el-image>
						<div 
						style='margin: 10px auto 0 auto;text-align: center;color: rgba(13,13,13,1);font-size: 24px;font-weight: 600;'>
							小主，你已在玩{{cloudGameHistory.name}}游戏是否结算下机,
						<br>
							开启其他游戏？
						</div>
					</el-col>
				</el-row>
				
				<el-row style='display: flex;margin-top: 30px;'>
					<el-col :span='20' style='margin: 10px auto;display: flex;justify-content: space-around;'>
						<el-button round @click='replayTipsShow = false;' class='btnHover2'
						style='background:#F8F8F8;border-color: #F8F8F8;color: #000;width: 214px;padding: 25px 0;border-radius: 36px;font-size:22px'>
							取消
						</el-button>
						<el-button round @click='replayTipsShow = false;historyPlayForGame = false;closeAfterOpen();' class='btnHover'
						style='background:rgba(249,221,74,1);border-color: rgba(249,221,74,1);color: #000;width: 214px;padding: 25px 0;border-radius: 36px;font-size:22px'>
							确定
						</el-button>
					</el-col>
				</el-row>
			</div>
		</el-dialog>

		<!-- 玩云电脑时  如果有游戏的重连状态的提醒 -->
		<!-- <el-dialog :visible.sync="replayTipsShow2"  width="528px"  :close-on-press-escape='false' :show-close='false' :lock-scroll='false'
			:close-on-click-modal='false' top='22vh' class='PlayStatusDialog'>
			<div class="content">
				<el-row style='display: flex;'>
					<el-col :span='24' style='margin: 10px auto;display: flex;flex-direction: column;'>
						<el-image :src="require('@/assets/game/pdwc@2x.png')" style='width: 200px;height: 200px;vertical-align: middle;margin: 0 auto;'>
						</el-image>
						<div 
						style='margin: 10px auto 0 auto;text-align: center;color: rgba(13,13,13,1);font-size: 24px;font-weight: 600;'>
							小主，你已在玩{{cloudGameHistory.name}}游戏是否结算下机,
						<br>
							开启其他游戏？
						</div>
					</el-col>
				</el-row>
				
				<el-row style='display: flex;margin-top: 30px;'>
					<el-col :span='20' style='margin: 10px auto;display: flex;justify-content: space-around;'>
						<el-button round @click='replayTipsShow2 = false;' class='btnHover2'
						style='background:#F8F8F8;border-color: #F8F8F8;color: #000;width: 214px;padding: 25px 0;border-radius: 36px;font-size:22px'>
							取消
						</el-button>
						<el-button round @click='replayTipsShow2 = false;historyPlayForGame = false;closeAfterOpenPC();' class='btnHover'
						style='background:rgba(249,221,74,1);border-color: rgba(249,221,74,1);color: #000;width: 214px;padding: 25px 0;border-radius: 36px;font-size:22px'>
							确定
						</el-button>
					</el-col>
				</el-row>
			</div>
		</el-dialog> -->

		<!-- A云游戏排队最小化时，点击B游戏给出提示 -->
		<el-dialog :visible.sync="replayTipsShow3"  width="528px"  :close-on-press-escape='false' :show-close='false' :lock-scroll='false'
			:close-on-click-modal='false' top='22vh' class='PlayStatusDialog'>
			<div class="content">
				<el-row style='display: flex;'>
					<el-col :span='24' style='margin: 10px auto;display: flex;flex-direction: column;'>
						<el-image :src="require('@/assets/game/pdwc@2x.png')" style='width: 200px;height: 200px;vertical-align: middle;margin: 0 auto;'>
						</el-image>
						<div 
						style='margin: 10px auto 0 auto;text-align: center;color: rgba(13,13,13,1);font-size: 24px;font-weight: 600;'>
							小主，你已有游戏处于排队状态是否结束,
						<br>
							并开启其他游戏？
						</div>
					</el-col>
				</el-row>
				
				<el-row style='display: flex;margin-top: 30px;'>
					<el-col :span='20' style='margin: 10px auto;display: flex;justify-content: space-around;'>
						<el-button round @click='replayTipsShow3 = false;' class='btnHover2'
						style='background:#F8F8F8;border-color: #F8F8F8;color: #000;width: 214px;padding: 25px 0;border-radius: 36px;font-size:22px'>
							取消
						</el-button>
						<el-button round @click='replayTipsShow3 = false;closeAfterOpenChange();' class='btnHover'
						style='background:rgba(249,221,74,1);border-color: rgba(249,221,74,1);color: #000;width: 214px;padding: 25px 0;border-radius: 36px;font-size:22px'>
							确定
						</el-button>
					</el-col>
				</el-row>
			</div>
		</el-dialog>

		<!-- 云电脑重连时  连接云游戏的提醒 -->
		<el-dialog :visible.sync="replayTipsShow4"  width="528px"  :close-on-press-escape='false' :show-close='false' :lock-scroll='false'
			:close-on-click-modal='false' top='22vh' class='PlayStatusDialog'>
			<div class="content">
				<el-row style='display: flex;'>
					<el-col :span='24' style='margin: 10px auto;display: flex;flex-direction: column;'>
						<el-image :src="require('@/assets/game/pdwc@2x.png')" style='width: 200px;height: 200px;vertical-align: middle;margin: 0 auto;'>
						</el-image>
						<div 
						style='margin: 10px auto 0 auto;text-align: center;color: rgba(13,13,13,1);font-size: 24px;font-weight: 600;'>
							小主，你的云电脑处于重连状态,是否下线,
						<br>
							并开启其他游戏？
						</div>
					</el-col>
				</el-row>
				
				<el-row style='display: flex;margin-top: 30px;'>
					<el-col :span='20' style='margin: 10px auto;display: flex;justify-content: space-around;'>
						<el-button round @click='replayTipsShow4 = false;' class='btnHover2'
						style='background:#F8F8F8;border-color: #F8F8F8;color: #000;width: 214px;padding: 25px 0;border-radius: 36px;font-size:22px'>
							取消
						</el-button>
						<el-button round @click='replayTipsShow4 = false;historyPlay=false;closeAfterOpenGame();' class='btnHover'
						style='background:rgba(249,221,74,1);border-color: rgba(249,221,74,1);color: #000;width: 214px;padding: 25px 0;border-radius: 36px;font-size:22px'>
							确定
						</el-button>
					</el-col>
				</el-row>
			</div>
		</el-dialog>

		<!-- 全局测速loading -->
		<div class='el-loading-mask is-fullscreen ' style='background-color: rgba(0, 0, 0, 0.8);'
			v-show='fullLoading'>
			<div class="fullLoadingClass">
				<div v-loading='fullLoading' element-loading-text="正在加载中..."></div>
				<!-- <div class='text'>正在加载中...</div> -->
			</div>
			
		</div>

		<!-- 新手礼包 -->
		<transition name="el-fade-in" >
			<!-- <div v-show="NoviceGiftShow" class="transition-box">.el-fade-in</div> -->
			<div class='el-loading-mask is-fullscreen' style='background-color: rgba(0, 0, 0, 0.8);z-index: 9999;'
				v-show="NoviceGiftShow">
				<div class="NoviceGift">
					<el-image class='lingqv' :src="require('@/assets/game/lingqvbtn.png')" @click.stop='getXinshou'></el-image>
				</div>
			</div>
		</transition>

		<!-- 新人充值豪礼1 -->
		<transition name="el-fade-in">
			<div class='el-loading-mask is-fullscreen' style='background-color: rgba(0, 0, 0, 0.8);z-index: 100;'
			v-show="haoli1Show">
				<div class="haoli">
					<img src="../assets/game/close.png" class="close-btn" @click="handleHaoLiClose()">
					<div class="haoli-title">
						VIP优先特权充值仅一次机会,不要错过哦
					</div>
					<div class="haoli-countdown">
						<img src="../assets/game/time.png" alt="" class="time-icon">
						距离活动结束：
						<span>{{countDownNum}}</span>
					</div>		
					<div class="haoli-cont">
						<div class="haoli-left-item haoli-item">
							<div class="haoli-txt-cont">
								<p class="money">充值:30元 <span style="font-weight: normal;text-decoration: line-through;">原价:50元</span></p>
								<p class="haoli-txt">成为VIP尊享优先特权<br>再送10000胖哒云游币</p>
							</div>
							<img src="../assets/game/btn-vip.png" class="btn-vip haoli-btn-item" alt="" @click="handleHaoliPay(97)">
						</div>
						<div class="haoli-right-item haoli-item">
							<div class="haoli-txt-cont" style="left: 37px;">
								<p class="money">充值:{{payProductActiveOrder.product_price}}元</p>
								<div class="haoli-txt">
									送 <span class="song-big">{{payProductActiveOrder.coin_count}}</span>胖哒云游币
									<p class="haoli-yuan">原{{payProductActiveOrder.product_price*10*10}}胖哒云游币</p>
								</div>
							</div>
							<img src="../assets/game/btn-pay.png" class="btn-pay haoli-btn-item" alt="" @click="handleHaoliPay(96)">
						</div>
					</div>
				</div>
			</div>
		</transition>

		<!-- 新人充值豪礼2 -->
		<transition name="el-fade-in">
			<div class='el-loading-mask is-fullscreen' style='background-color: rgba(0, 0, 0, 0.8);z-index: 100;'
			v-show="haoli2Show">
				<div class="haoli haoli2">
					<img src="../assets/game/close.png" class="close-btn" @click="handleHaoLiClose()">
					<div class="haoli-title">
						VIP优先特权充值仅一次机会,不要错过哦
					</div>
					<div class="haoli-countdown">
						<img src="../assets/game/time.png" alt="" class="time-icon">
						距离活动结束：
						<span>{{countDownNum}}</span>
					</div>		
					<div class="haoli-cont">
						<div class="haoli-right-item haoli-item">
							<div class="haoli-txt-cont" style="left: 32px;" :style="{'left':(payProductActiveOrder.id>=100?'22px':'32px')}">
								<p class="money">充值:{{payProductActiveOrder.product_price}}元</p>
								<div class="haoli-txt">
									送 <span class="song-big">{{payProductActiveOrder.coin_count}}</span>胖哒云游币
									<p class="haoli-yuan">原{{payProductActiveOrder.product_price*10*10}}胖哒云游币</p>
								</div>
							</div>
							<img src="../assets/game/btn-pay.png" class="btn-pay haoli-btn-item" alt="" @click="handleHaoliPay()">
						</div>
					</div>
				</div>
			</div>
		</transition>

		<!-- 会员专属游戏/ -->
		<el-dialog :visible.sync="ismemberStatus"  width="528px"  :close-on-press-escape='false' :show-close='false' :lock-scroll='false'
			:close-on-click-modal='false' top='22vh' class='PlayStatusDialog'>
			<div class="content">
				<el-row style='display: flex;'>
					<el-col :span='18' style='margin: 10px auto;display: flex;flex-direction: column;'>
						<!-- <el-image :src="require('@/assets/game/pdwc@2x.png')" style='width: 200px;height: 200px;vertical-align: middle;margin: 0 auto;'>
						</el-image> -->
						<div 
						style='margin: 10px auto 0 auto;width: 300px;text-align: center;color: #BB8858;font-size: 40px;font-weight: 600;margin-bottom:30px'>
							会员专属游戏
						<br>
						</div>
						<div style="width: 354px;height: 31px;font-size: 24px;font-family: MicrosoftYaHei;color: #6D7278;line-height: 31px;">
							成为会员即刻畅玩百款+专属游戏
						</div>
					</el-col>
				</el-row>
				
				<el-row style='display: flex;margin-top: 30px;'>
					<el-col :span='20' style='margin: 10px auto;display: flex;justify-content: space-around;'>
						<el-button round @click='ismemberStatus = false;' class='btnHover2'
						style='background:#F8F8F8;border-color: #F8F8F8;color: #000;width: 214px;padding: 25px 0;border-radius: 36px;font-size:22px'>
							算了吧
						</el-button>
						<el-button round @click='getProducts();ismemberStatus = false; dialogShow = true;' class='btnHover'
						style='background:rgba(249,221,74,1);border-color: rgba(249,221,74,1);color: #000;width: 214px;padding: 25px 0;border-radius: 36px;font-size:22px'>
							成为会员
						</el-button>
					</el-col>
				</el-row>
			</div>
		</el-dialog>

		<!-- 充值二维码弹窗 -->
		<transition name="el-fade-in">
			<div class='el-loading-mask is-fullscreen' style='background-color: rgba(0, 0, 0, 0.8);z-index: 100;'
			v-show="haoliPayShow">
				<div class="haoliPay">
					<img src="../assets/game/close.png" class="close-btn" @click="handleHaoLiPayClose()">
					<img src="../assets/game/pay-title.png" class="pay-title">
					<div class="haolipay-part">
						<div class="pay-cont">
							<div class="qr-code" id="haoli-code">
								<VueQr :margin='0' :size='160' :text='qr_text'></VueQr>
							</div>
							<p class="money">扫码支付: <span>{{payProductActiveOrder.product_price}}</span>元	</p>
						</div>
						<div class="pay-type">
							<!-- <div class="type-item" :class="{'is-select':haoliPayType=='wxpay'}" @click="selectHaoliPayType('wxpay')" style="border-bottom-left-radius: 20px;">
								<img src="../assets/game/wx.png" alt="">
								微信支付
							</div> -->
							<div class="type-item" :class="{'is-select':haoliPayType=='alipay'}" @click="selectHaoliPayType('alipay')" style="border-bottom-right-radius: 20px;">
								<img src="../assets/game/ali.png" alt="">
								支付宝支付
							</div>
						</div>
					</div>
				</div>
			</div>
		</transition>
		
	</div>
</template>

<script>
	import Vue from 'vue';
	import MyFooter from '@/components/footer';
	// import Swiper from "swiper";
	// import "swiper/swiper-bundle.min.js";
	import "swiper/swiper-bundle.min.css";
	import {Message,Loading} from 'element-ui';
	// import { swiper, swiperSlide } from "vue-awesome-swiper";
	import { videoPlayer } from 'vue-video-player'
	import 'video.js/dist/video-js.css'
	Vue.use(Loading);
	import VueQr from 'vue-qr';
	export default{
		name:'gameDetail',
		components:{
			MyFooter,
			VueQr,
			videoPlayer
        },
		data(){
			return{
				ismemberStatus:false,
				getGameId:"",
				gameDetail:{},
				isDetailBannerShow:false,
				isSwiperShow:false,
				mySwiper:{},
				thumbsSwiper:{},
				isAgainBtnShow:false,
				notMoney:false,
				pingShow:false,
				isPlayStatus:false,
				regionText:'',
				isGameIframeShow:false,
				RanksDialog:false,
				historyPlayForGame:false, //云游戏历史记录
				historyPlay:false,
				replayTipsShow:false,
				replayTipsShow2:false,
				replayTipsShow3:false,
				replayTipsShow4:false,
				disableGame:false,
				// 排队
				isVip:null,
				vipLevel:null,
				GameChoseRadio:{},
				cloudGameHistoryRegion:'', //云游戏历史记录的机房ip
				cloudGameHistory:{}, // 云游戏重连按钮显示哪一个的条件对象
				CostArr:[],//收费标准数组
				regionList:[],
				regionList2:[],
				region:'',
				miaoPlay:false,
				choseRadio:{},
				huanqvDialog:false,
				fullLoading:false,
				NoviceGiftShow:false,
				userInfo:{},
				changeGame:{},//A云游戏排队最小化时，点击B游戏的数据存储
				swiperOption:{
					observer: true,
					observeParents:true,
					allowTouchMove:true,
					autoplay:{
						delay:3000,
						stopOnLastSlide:false,
						disableOnInteraction : false,
					},
					thumbs: {
						swiper: this.thumbsswiper,
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					slideThumbActiveClass: 'swiper-slide-thumb-active',
				},
				swiperThumbsOption:{
					observer: true,
					spaceBetween: 10,
					slidesPerView: 5,
					watchSlidesVisibility: true,
				},
				swiperIndex:0,

				payProductList:[],
				payProductActiveOrder:{},
				countDownTimer:null,
				countDownNum:0,
				haoli1Show:false,
				haoli2Show:false,
				haoliPayShow:false,
				haoliPayType:"wxpay",
				haoliPayTimer:null,
				miniActiveShow:false,
				qr_text:'',
				
				channel:"",
				isBtnDisabled:false,
				banGameIDList:[128,130,205,203,229,100,145,88,91,37,42,86,106,117,121,125],
				playVideoIndexArr:[]
				
			}
		},
		computed: {
			myswiper() {
				return this.$refs.mySwiper.swiper
			},
			thumbsswiper() {
				return this.$refs.thumbsSwiper.swiper
			},
		},
		updated(){
			// this.$nextTick(() => {
			// 	const swiperTop = this.$refs.mySwiper.swiper
			// 	const swiperThumbs = this.$refs.thumbsSwiper.swiper
			// 	swiperTop.controller.control = swiperThumbs
			// 	// swiperThumbs.controller.control = swiperTop
			// })
		},
		created() {
			let that=this
			that.getGameId=that.$route.query.gameId
			if(that.$route.query.gameId){
				that.getGameId=that.$route.query.gameId
			}else{
				that.getGameId=11
			}

			that.$utils.checkBrowser();
			if(window._BrowserName == 'IE' || window._BrowserName == 'Firefox' || window._BrowserName == 'Safari'){
				// 触发IE的提示框  不能进行云游戏
				that.$bus.$emit('isIEShow',true);
				that.isBtnDisabled=true
			}else{
				try {
					let testRTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection || window.RTCIceGatherer;
					if (testRTCPeerConnection) {
						let serverConfig = {
						"iceServers": [{
							urls: [
							"stun:stun.l.google.com:19302",
							"stun:stun1.l.google.com:19302",
							"stun:stun2.l.google.com:19302",
							"stun:stun.l.google.com:19302?transport=tcp"
							]
						}]
						};
						new RTCPeerConnection(serverConfig);
						return true;
					} else {
						that.$bus.$emit('isIEShow',true);
						that.isBtnDisabled=true
						console.error("当前浏览器不支持该功能");
					}
				} catch (error) {
					that.$bus.$emit('isIEShow',true);
					that.isBtnDisabled=true
					console.error("当前浏览器不支持该功能")
					return false;
				}
			}
		},
		mounted() {
			let that=this
			that.$bus.$emit('setActiveIndex',1);
			that.getGameDetail()

			if(that.$utils.checkLogin()){
				that.getLoginInfo();
				if(sessionStorage.getItem('gameId')){
					sessionStorage.setItem('gameId',that.getGameId)
				}
			}else{
				// that.$utils.Burying({
				// 	act:'welcomeGameDetail',
				// 	user_attribute:'new',
				// 	operating_system:'web',
				// 	Visit_time:new Date().toISOString(),
				// 	Game_id:that.getGameId,
				// });
			}

			window._vue = function(){
				console.info(that);
				return that;
			}

			that.myswiper.on("slideChangeTransitionStart",function(){
				that.swiperIndex=this.activeIndex
			})
			that.myswiper.on("slideChangeTransitionEnd",function(){
				let videoGroup=document.getElementById("mySwiper").getElementsByTagName("video")
				for(let i=0;i<videoGroup.length;i++){
					videoGroup[i].pause()
				}
				that.playVideoIndexArr.forEach((item)=>{
					if(item==that.swiperIndex){
						document.getElementById("swiperVideo"+that.swiperIndex).getElementsByTagName("video")[0].play()
						// document.getElementById("swiperVideo"+that.swiperIndex).getElementsByTagName("video")[0].onplay=function(){
						// 	document.getElementById("swiperVideoPlayIcon"+that.swiperIndex).style.display="none"
						// }
						// document.getElementById("swiperVideo"+that.swiperIndex).getElementsByTagName("video")[0].onpause=function(){
						// 	if(document.getElementById("swiperVideoPlayIcon"+that.swiperIndex)){
						// 		document.getElementById("swiperVideoPlayIcon"+that.swiperIndex).style.display="block"
						// 	}
						// }
					}
				})
			})
		},
		methods:{
			getWheel(e){
				return e;
			},
			getOtherInfo(){
				return document.querySelector('#frameDiv').onmousewheel();
			},
			getLoginInfo() {
				let that = this;
				let url = 'api/v1/cloud_pc/app/user_info';
				that.$req.post(url, {})
					.then(res => {
						if (res.data) {
							that.userInfo = res.data;
							let str = res.data.phone;
							that.userInfo.phone2 = str.substr(0,3)+'****'+str.substr(7,str.length);
							if(res.data.new_pkg == 0){
								that.NoviceGiftShow = true;
								// document.querySelector('.NoviceGift').style.display = '';
							}else{
								that.NoviceGiftShow = false;
								// localStorage.setItem('new_pkg',1);

								if(res.data.growth_value<=0){
									if(localStorage.getItem("miniActive")=="true"){
										that.miniActiveShow=true
									}else{
										that.getPayProductList()
									}
								}
							}
							// that.$utils.Burying({
							// 	act:'welcomeGame',
							// 	user_attribute:'old',
							// 	userID:JSON.parse(localStorage['login']).user_id,
							// 	phone:that.userInfo.phone,
							// 	operating_system:'web',
							// 	Registration_time:that.userInfo.create_time,
							// 	Visit_time:new Date().toISOString(),
							// });
							setTimeout(()=>{
								that.getHistorys();
							},500)
						}
					})
					.catch(err => {
						console.error(err);
					})
			},
			getGameDetail(){
				let that=this
				let url = 'api/v2/cloud_pc/app/game/'+that.getGameId;
				that.$req.get(url, {})
					.then(res=>{
						if(res.Code==0){
							that.gameDetail=res.Data
							// that.gameDetail.config_id=28
							that.gameDetail.logo_detail2=JSON.parse(res.Data.logo_detail2)
							sessionStorage.setItem('gameName',that.gameDetail.name)
							that.isDetailBannerShow=true
							that.isSwiperShow=true
							that.gameDetail.logo_detail2.forEach((item,key)=>{
								let index=item.url.lastIndexOf(".")
								let	tv_id=item.url.substring(index);
								if(tv_id==".mp4"||tv_id==".rmvb"||tv_id==".avi"||tv_id==".ts"||tv_id==".flv"){
									that.myswiper.autoplay.stop()
									that.myswiper.allowTouchMove=false
									that.playVideoIndexArr.push(key)
									that.$set(that.gameDetail.logo_detail2[key],"isVideo",true)
									let isAutoplay=false
									if(key==0){
										isAutoplay=false
									}else{
										isAutoplay=false
									}
									that.$set(that.gameDetail.logo_detail2[key],"playerOptions",{
										playbackRates: [0.5, 1.0, 1.5, 2.0], 
										autoplay: isAutoplay, 
										muted: false, 
										loop: false, 
										preload: 'auto', 
										language: 'zh-CN',
										aspectRatio: '42:23', 
										fluid: true, 
										sources: [{
											type: "", 
											src: item.url
										}],
										notSupportedMessage: '此视频暂无法播放，请稍后再试', 
										controlBar: {
											timeDivider: true, 
											durationDisplay: true, 
											remainingTimeDisplay: true, 
											fullscreenToggle: true 
										}
									})
									return 
								}else{
									that.$set(that.gameDetail.logo_detail2[key],"isVideo",false)
									return 
								}
							})
							
							that.$utils.Burying({
								act:'welcomeGameDetail',
								user_attribute:'old',
								operating_system:'web',
								Visit_time:new Date().toISOString(),
								Game_id:that.getGameId,
								Game_name:that.gameDetail.name,
							});
							
						}else{
							that.getGameId=11
							that.getGameDetail()
						}
					}).catch(err=>{
						console.error(err);
					})
			},
			clickThumbs(key){
				let that=this
				// that.mySwiper.slideTo(key,1000,false)
				that.myswiper.slideTo(key,500,true)
			},
			//获取机房历史记录  接口区分是云游戏/云电脑
			getHistorys(){
				let that = this;
				// 如果之前有在最小化排队时刷新网页 需要重新打开
				let isBigWait = sessionStorage['isBigWait'];
				if(isBigWait == 'true'){
					let dom = document.createElement('iframe');
					dom.id = 'gameWindow';
					dom.className = 'gameWindow';
					dom.src = 'static/iframe/gaming.html';
					dom.width = '100%';
					dom.height = '100%';
					dom.style.display = '';
					document.querySelector('#frameDiv').appendChild(dom);
					that.RanksDialog = true
					that.isGameIframeShow=true
					
				}else if(isBigWait == 'false'){
					let dom = document.createElement('iframe');
					dom.id = 'gameWindow';
					dom.className = 'gameWindowMini';
					dom.src = 'static/iframe/gaming.html';
					dom.width = '300px';
					dom.height = '200px';
					dom.style.display = '';
					document.querySelector('#frameDiv').appendChild(dom);
					that.RanksDialog = false
					that.isGameIframeShow=true
					// 最小化时 将换区禁用
					that.$refs['huanqvBtn'].$el.style.opacity = .65;
					that.$refs['huanqvBtn'].$el.style.pointerEvents  = 'none';
					// 恢复页面滚动
					document.querySelector('body').style.overflow = '';
					
				}

				let url = 'api/v2/cloud_pc/server/game/findgame';
				let data = {
					user_id:that.userInfo.user_id
				};
				let result;
				// 获取收费标准
				that.getCost()
				that.$req.post(url,data)
				.then(res=>{
					if(res.Code == 0 && res.Data&&res.Data != null){
						result = res.Data;
						if(res.Data.game_id==that.getGameId){
							that.isAgainBtnShow=true
						}else{
							that.isAgainBtnShow=false
						}
					}
					let url2 = 'api/v1/cloud_pc/app/machine_list';
					let data2 = {
						"dev_type":"windows",
						"type":1  ,// 1 app 2客户端 
					};
					
					// let res2 =;
					return new Promise((resolve)=>{
						resolve(that.$req.post(url2,data2))
					})
				})
				
				.then((res2)=>{
					setTimeout(()=>{
						let result2;
						if(res2.code == 0){
							// result2 = res2.data.filter(item => {
							// 	return item.mobile_game_switch != 1 && item.tecent_switch != 1 && item.web == 0 && item.status == 0
							// }) || [];
							result2 = res2.data
							
							// 获取收费标准
							let arr2 = [];
							// 将收费标准并入到数据
							if(that.CostArr.length >0){
								result2.map((k)=>{
									that.CostArr.map((k2)=>{
										if(k.config_id == k2.config_id){
											k.normal_cost = k2.normal_cost;
											k.vip_cost = k2.vip_cost;
											arr2.push(k)
										}
									})
								})
							}
							
							arr2.sort((a,b)=>{
								if(typeof a.normal_cost == 'undefined'){
									a.normal_cost = 0;
								}
								if(typeof b.normal_cost == 'undefined'){
									b.normal_cost = 0;
								}
								
								if(a.normal_cost > b.normal_cost){
									return -1
								}else if(a.normal_cost < b.normal_cost){
									return 1
								}
								
							})
							
							// 登录状态下的机房列表
							that.regionList = [...arr2];
							// 未登录状态下的机房列表
							that.regionList2 = that.regionList;
							// 设置选区默认值
							that.region = arr2[0].name;
						}
						if(result){
							if(result.is_cloud_game == 1){
								let cloudGameHistory = {};
								if(localStorage['cloudGame']&&typeof localStorage['cloudGame'] !='undefined'){
									cloudGameHistory = JSON.parse(localStorage['cloudGame']);
								}
								//云游戏有历史
								that.historyPlayForGame = true;
								that.cloudGameHistory.ID = result.game_id;
								that.cloudGameHistory.name = cloudGameHistory.name;
								// 将重连机房获取并选择
								result2.map((k)=>{
									k.room_list.map((k2)=>{
										if(k2.id == result.room_id){
											that.cloudGameHistoryRegion = k2;
											that.GameChoseRadio = k2;
											localStorage.setItem('gameChoseRadio',JSON.stringify(that.GameChoseRadio));
											localStorage.setItem('gameConfigID',result.config_id);
										}
									})
								})
								// // 显示重连按钮
								// that.cloudGameList.map((k,v)=>{
								// 	if(k.ID == result.game_id){
								// 		k.replay = true;
								// 	}else{
								// 		k.replay = false;
								// 	}
								// 	that.$set(that.cloudGameList,v,k);
								// })
								that.miaoPlay = true;
							}else if(result.is_cloud_game == 0){
								that.historyPlay = true;
								//将秒玩按钮显示
								that.miaoPlay = true;
								// 云电脑有历史
								
								// 如果之前有在最小化排队时刷新网页 需要重新打开
								let isBigWait = sessionStorage['isBigWait'];
								if(isBigWait == 'true'){
									let dom = document.createElement('iframe');
									dom.id = 'gameWindow';
									dom.className = 'gameWindow';
									dom.src = '../../cloudgame/html/gaming.html';
									dom.width = '100%';
									dom.height = '100%';
									dom.style.display = '';
									document.querySelector('#frameDiv').appendChild(dom);
									that.RanksDialog = true;
									// 显示历史选区
									that.region = JSON.parse(localStorage['befourRegion']);
									that.choseRadio = JSON.parse(localStorage['region']);
									that.regionText = that.region +' > '+ that.choseRadio.name;
									// 显示历史选区
									that.title2Show = true;
								}else if(isBigWait == 'false'){
									let dom = document.createElement('iframe');
									dom.id = 'gameWindow';
									dom.className = 'gameWindowMini';
									dom.src = '../../cloudgame/html/gaming.html';
									dom.width = '300px';
									dom.height = '200px';
									dom.style.display = '';
									document.querySelector('#frameDiv').appendChild(dom);
									that.RanksDialog = false;
									// 最小化时 将换区禁用
									that.$refs['huanqvBtn'].$el.style.opacity = .65;
									that.$refs['huanqvBtn'].$el.style.pointerEvents  = 'none';
									// 恢复页面滚动
									document.querySelector('body').style.overflow = '';
									// 显示历史选区
									that.region = JSON.parse(localStorage['befourRegion']);
									that.choseRadio = JSON.parse(localStorage['region']);
									that.regionText = that.region +' > '+ that.choseRadio.name;
									// 显示历史选区
									// that.title2Show = true;
								}
								
								// 如果有历史选区
								if(localStorage['region'] && typeof localStorage['region'] !='undefined'){
									that.region = JSON.parse(localStorage['befourRegion']);
									that.choseRadio = JSON.parse(localStorage['region']);
									that.regionText = that.region +' > '+ that.choseRadio.name;
									// 显示历史选区
									// that.title2Show = true;
								}else{
									result2.map((k)=>{
										if(k.config_id == result.config_id){
											that.region = k.name;
											k.room_list.map((k2)=>{
												if(k2.id == result.room_id){
													that.choseRadio = k2;
													that.regionText = that.region +' > '+ that.choseRadio.name;
													// 显示历史选区
													// that.title2Show = true;
													// 将接口选区数据 存入缓存内
													localStorage.setItem('befourRegion',JSON.stringify(that.region));
													localStorage.setItem('region',JSON.stringify(that.choseRadio))
												}
											})
										}
									})
								}
							}
						}else{
							//将秒玩按钮显示
							that.miaoPlay = true;
						}
						// 如果有历史选区
						if(localStorage['region'] && typeof localStorage['region'] !='undefined'){
							that.region = JSON.parse(localStorage['befourRegion']);
							that.choseRadio = JSON.parse(localStorage['region']);
							that.regionText = that.region +' > '+ that.choseRadio.name;
							// 显示历史选区
							// that.title2Show = true;
						}
					},500)
				})
				
			},
			notLoginPlay(item){
				let that = this;
				if(!that.$utils.checkLogin()){
					sessionStorage.setItem('notLoginPlayGame',JSON.stringify(item));
					sessionStorage.removeItem('notLoginPlayPC');
					that.$bus.$emit('loginDialogShow',true);
				}
			},
			openCloudGame(isreplay){
				let that = this;
				if(JSON.parse(sessionStorage.getItem("userInfo")).free_time<=0 && that.gameDetail.high_config_area_flag == 2){
					that.ismemberStatus = true
					return
				}
				if(that.isBtnDisabled){
					that.$bus.$emit('isIEShow',true);
					return
				}
				let item=that.gameDetail
				let gameName = item.Game?item.Game.name:item.name;
				that.changeGame = item.Game?item.Game:item;
				
				// 检测用户余额
				let info = JSON.parse(sessionStorage['userInfo']);
				console.log(info.tota_time + info.free_time)
				if(info.tota_time + info.free_time< 60&&isreplay!=true){
					Message.warning("你的剩余时长不足，请马上充值")
					// that.$bus.$emit('RechargeDialogShow',true);
					that.notMoney = true;
					return;
				}

				// 选区检测
				if(!that.GameChoseRadio.id||that.GameChoseRadio.id == ''){
					// 没有选区
					that.fullLoading = true;
					that.replayItem = item.Game?item.Game:item;
					that.cloudGameRegionChose();
					return;
				}
				// let str = JSON.parse(localStorage['gameChoseRadio']).room_ip[0];
				let str = that.GameChoseRadio.room_ip[0];
				let ip = str.substr(0,str.indexOf(':'));
				if(that.check_client(ip,'game')){
					that.isPlayStatus = true;
					return;
				}

				if(document.querySelector('#gameWindow')){
					// 当前排队最小化时  需要区分是否是当前游戏的排队  还是点击了其他游戏
					if(gameName == sessionStorage['gameName']){
						document.querySelector('#gameWindow').contentWindow.sendLineShow();
						that.miniIframe('100%','100%')
					}else{
						that.replayTipsShow3 = true;
					}
					
					return;
				}

				// 如果在重连状态下 点击非重连游戏
				if(that.historyPlayForGame){
					that.replayItem = item;
					that.replayTipsShow = true;
					return;
				}
				// 如果在云电脑重连状态下  点击云游戏
				if(that.historyPlay){
					that.replayItem = item;
					that.replayTipsShow4 = true;
					return;
				}

				// 将其他云游戏按钮禁用
				that.disableGame = true;
				
				//游戏记录同步
				let obj = item.Game?item.Game.ID:item.ID;
				sessionStorage.setItem('gameId',obj);
				sessionStorage.setItem('gameName',gameName);
				that.$utils.Burying({
					act:'changeGame',
					user_attribute:'old',
					userID:JSON.parse(localStorage['login']).user_id,
					phone:that.userInfo.phone,
					operating_system:'web',
					Registration_time:that.userInfo.create_time,
					On_board_time:new Date().toISOString(),
					Game_name:gameName,
				});
				that.ReportingGames(obj);
				let isvip  = JSON.parse(sessionStorage['userInfo']).vip_type == 0?false:true;
				let vipLevel = JSON.parse(sessionStorage['userInfo']).vip_level;
				that.isVip = isvip;
				that.vipLevel = vipLevel;
				// 显示蒙层
				that.RanksDialog = true
				that.isGameIframeShow=true
				// 禁止页面滚动
				document.querySelector('body').style.overflow = 'hidden';
				// console.info(item);
				let dom = document.createElement('iframe');
				dom.id = 'gameWindow';
				dom.className = 'gameWindow';
				dom.src = 'static/iframe/gaming.html';
				dom.width = '100%';
				dom.height = '100%';
				dom.style.display = '';
				document.querySelector('#frameDiv').appendChild(dom);
			},
			//查询用户是否已经发起了连接
			check_client(ip,checkMsg){
				let that = this;
				let url = 'wss://'+ip+':2235/msg '
				var ws = new WebSocket(url);
				let data = {
					"cmd": "check_client",	//cmd 命令
					"hostname": that.userInfo.user_id,	//通过后台登录可以获取
					"token": JSON.parse(localStorage['login']).token, 		//通过后台登录可以获取
					"is_cloud_game": false    //请求的是云电脑还是云游戏 true表示云游戏 
				};
				if(checkMsg == 'pc'){
					data.is_cloud_game = false;
				}else if(checkMsg == 'game'){
					data.is_cloud_game = true;
				}
				let isPlay = false;
				ws.onopen = function(){
					ws.send(JSON.stringify(data));
					setTimeout(()=>{
						ws.close();
					},500)
					
				}
				ws.onmessage = function(e){
					// console.info(JSON.parse(e.data));
					let result = JSON.parse(e.data);
					if(result.code === 1){
						isPlay = true;
					}
				}
				return isPlay;
			},
			// 获得收费标准 用以给区域排序
			getCost(){
				let that = this;
				let url = 'api/v1/cloud_pc/app/game_list';
				that.$req.post(url,{type:1},{timeout:3000})
				.then(res=>{
					if(res.code === 0){
						that.CostArr = res.data;
					}
				})
			},
			getProducts(){
				let that = this;
				if(that.$utils.checkLogin()){
					that.$utils.Burying({
						act: 'zhudongchongzhi',
						user_attribute: 'old',
						userID: JSON.parse(localStorage['login']).user_id,
						phone: that.userInfo.phone,
						operating_system: 'web',
						Registration_time: that.userInfo.create_time,
					});	

					that.$bus.$emit('RechargeDialogShow',true);
				}else{
					that.$bus.$emit('loginDialogShow',true);
				}
			},
			cloudGameRegionChose(){
				let that = this;
				
				let requrl = 'api/v1/cloud_pc/app/machine_list';
				let data = {
					"dev_type":"windows",
					"type":1  ,// 1 app 2客户端 
				};
				
				that.$req.post(requrl,data)
				.then(res=>{
					let baseArr = [];
					if (res.code === 0) {
						// let serverList = res.data.filter(item => {
						// 	return item.mobile_game_switch != 1 && item.tecent_switch != 1 && item.web == 0 && item.status == 0
						// }) || [];
						let serverList = res.data

						serverList.map((k)=>{
							if(k.config_id == that.replayItem.config_id){
								baseArr.push(k);
							}
						})
					}
					// 测速代码
					let url,port = '';
					let reqArr = [];
					baseArr.map((item)=>{
						if(item.config_id == that.replayItem.config_id){
							item.room_list.map((item2)=>{
								port = item2.app_link_ip.substr(0,item2.app_link_ip.indexOf(':'));
								// url = 'wss://'+port+':2234/ping';
								url = 'wss://'+port+':2235/ping';
								reqArr.push({url:url,id:item2.id,name:item2.name});
							})
						}
						
					});
					
					if("WebSocket" in window){
						var Socket = [];
						let timer,sTime,eTime;
						let countLength = reqArr.length;
						reqArr.map((item,i)=>{
							Socket[i] = new WebSocket(item.url);
							// 检测ws是否超时 超时关闭流程
							setTimeout(()=>{
								if(Socket[i].readyState === 0){
									console.info(Socket[i].url+'连接超时,已自动关闭')
									Socket[i].close();
								}
							},3000)
							Socket[i].onopen = function(){
								timer=setInterval(()=>{
									if(Socket[i].readyState !== 1){
										clearInterval(timer);
										return;
									}
									sTime = new Date().getTime();
									let data = {
										"cmd":'ping',
										"body":{
											"time":sTime,
										}
									};
									// console.info(JSON.stringify(data));
									Socket[i].send(JSON.stringify(data));
								},200);
								
								
								// 正常关闭流程
								setTimeout(()=>{
									// 4s后结束ws
									Socket[i].close();
									
								},3000)
								
								// console.info(Socket[i])
								// console.info('已经连接.')
							};
							// ping值 队列
							let pingMS = {
								arr:[]
							};
							Socket[i].onmessage  = function(e){
								pingMS.id = item.id;
								// console.info(Socket[i]);
								// console.info(JSON.parse(e.data));
								eTime = JSON.parse(e.data).body.time;
								if(eTime){
									pingMS.arr.push((new Date().getTime() - eTime) % 1000);
								}else{
									pingMS.arr.push('超时');
								}
								// console.info(pingMS.arr)
								
							};
							Socket[i].onerror = function () {
								// console.info(Socket[i]+'连接失败.')
								// console.info(e);
							};
							Socket[i].onclose = function(){
								// console.info(Socket[i])
								// console.info('已经关闭.')
								// console.info(pingMS)
				
								// 剔除超时数据 获得有效值
								let yxz = pingMS.arr.filter((item)=>{
									if(item !='超时'){
										return true;
									}
								});
								if(yxz.length>1){
									// 计算平均值=有效ping值总和/4
									// 第一轮计算
									let count = yxz.reduce((prev,next)=>{
										return prev + next;
									})
									let val = (count/yxz.length).toFixed(0);
									// console.info('第一轮平均'+val+'ms.');
									// 第二轮计算
									let yxz2 = yxz.filter((item)=>{
										if(item <= (val*2)){
											return true;
										}
									});
									let count2 = yxz2.reduce((prev,next)=>{
										return prev + next;
									});
									let val2 = (count2/yxz2.length).toFixed(0);
									// console.info('第二轮平均'+val2+'ms.');
									// 获得ping值
									pingMS.value = val2;
								}
								// 将ping值合并到原数据
								baseArr.map((item,i)=>{
									item.room_list.map((item2)=>{
										if(pingMS.id == item2.id){
											item2.value = Number(pingMS.value);
											that.$set(baseArr,i,item);
										}
									
									})
								});
								
								countLength--;
								
								if(countLength === 0 ){
									baseArr.map((k,v)=>{
										k.room_list.map((k2)=>{
											if(!k2.value||k2.value == ''){
												k2.value = '9999';
											}
											that.$set(baseArr,v,k);
										})
									}) 
									let temparr  = baseArr;
									temparr.map((item)=>{
										item.room_list.sort((a,b)=>{
											if(a.value >b.value){ 
												return 1
											}else if(a.value== b.value){ 
												return 0
											}else if(a.value<b.value){
												return -1
											}
										})
									});
									let afterArr = [...temparr];
									// console.info(afterArr)
									// 设置游戏自动选区 
									let gameChoseRadio = afterArr[0].room_list[0];
									that.GameChoseRadio = gameChoseRadio;
									localStorage.setItem('gameChoseRadio',JSON.stringify(gameChoseRadio));
									localStorage.setItem('gameConfigID',afterArr[0].config_id);
									//选区loading结束
									that.fullLoading = false;
									that.openCloudGame();
									
								}
							};
							
						});
						
					}else{
						Message.warning('您的浏览器不支持 WebSocket!')
					}	
					
				})
			},
			// 重连云游戏
			replayCloudGame(){
				let that = this;
				if(that.isBtnDisabled){
					that.$bus.$emit('isIEShow',true);
					return
				}
				// 取消重连判定状态
				that.historyPlayForGame = false;
				// 将重连获取到的选区赋值给 秒玩选区
				that.GameChoseRadio = that.cloudGameHistoryRegion;
				that.openCloudGame(true);
			},
			miniIframe(width,height){
				let that = this;
				let dom = document.querySelector('#gameWindow');
				dom.width= width?width:'280px';
				dom.height = height?height:'190px';
				if(width ==='100%'&& height === '100%'){
					dom.className = 'gameWindow';
					that.RanksDialog = true
					that.isGameIframeShow=true
					// that.$refs['huanqvBtn'].$el.style.opacity = 1;
					// that.$refs['huanqvBtn'].$el.style.pointerEvents  = '';
					// 禁止页面滚动
					document.querySelector('body').style.overflow = 'hidden';
				}else{
					dom.className = 'gameWindowMini';
					that.RanksDialog = false
					that.isGameIframeShow=true
					// 最小化时 将换区禁用
					// that.$refs['huanqvBtn'].$el.style.opacity = .65;
					// that.$refs['huanqvBtn'].$el.style.pointerEvents  = 'none';
					// 恢复页面滚动
					document.querySelector('body').style.overflow = '';
				}
			},
			closeCloudGame(){
				let that = this;
				if(that.isBtnDisabled){
					that.$bus.$emit('isIEShow',true);
					return
				}
				let str = that.cloudGameHistoryRegion.app_link_ip;
				let ip = str.substr(0,str.indexOf(':'));
				// let ip = 'test-bky.cloudpc.cn';
				let url = 'wss://'+ip+':2235/msg';
				let data = {
					"cmd": "logout",		//cmd 命令
					"hostname": that.userInfo.user_id,	//通过后台登录可以获取
					"token": JSON.parse(localStorage['login']).token, 		//通过后台登录可以获取
					"is_cloud_game": true    //请求的是云电脑还是云游戏 true表示云游戏
				};
				let ws = new WebSocket(url);
				ws.onopen = function(){
					ws.send(JSON.stringify(data));
					setTimeout(()=>{
						ws.close();
					},500)
				}
				ws.onmessage = function(e){
					// console.info(e.data)
					let result = JSON.parse(e.data);
					if(result.code == 1){
						Message.success('注销成功.')
						setTimeout(()=>{
							location.reload();
							// that.reloadMounted()
						},1000)
					}else{
						Message.warning('注销失败.')
					}
				}					
			},
			huanqv(){
				let that = this;
				if(that.historyPlay){
					that.huanqvDialog = true;
				}else{
					that.pingShow = true;
				}
			},
			outGame(){
				let that = this;
				let str = that.choseRadio.room_ip[0];
				let ip = str.substr(0,str.indexOf(':'));
				// let url = 'wss://'+ip+':2234/msg';
				let url = 'wss://'+ip+':2235/msg';
				
				let data = {
					"cmd": "logout",
					"hostname":JSON.parse(sessionStorage['userInfo']).user_id,	//通过后台登录可以获取
					"token":JSON.parse(localStorage['login']).token 		//通过后台登录可以获取
				};
				let socket = new WebSocket(url);
				socket.onopen = function(){
					socket.send(JSON.stringify(data));
				}
				socket.onmessage = function(e){
					let result = JSON.parse(e.data);
					if(result.code === 1||result.code === 0){
							//清除本地历史游戏记录
							// localStorage.removeItem('gameListIndex');
							localStorage.removeItem('region');
							localStorage.removeItem('befourRegion');
							localStorage.removeItem('configID')
							location.reload();
							// that.reloadMounted()
					}
					if(result&&result!=null){
						socket.close();
					}
				}
				socket.onclose = function(){
					
				}
			},
			getXinshou(){
				let that = this;
				that.$utils.Burying({act:'geiXinShouLiBao',user_attribute:'old',userID:JSON.parse(localStorage['login']).user_id,operating_system:'web'});
				that.huoqvLibao();
				that.NoviceGiftShow = false;
			},
			huoqvLibao(){
				let that = this;
				let url = 'api/v1/cloud_pc/app/new_pkg';
				that.$req.post(url,{})
				.then(res=>{
					// console.info(res);
					if(res.code == 0){
						Message.success(res.info);
						that.$bus.$emit('getLogin');
						if(that.userInfo.growth_value<=0){
							if(localStorage.getItem("miniActive")=="true"){
								that.miniActiveShow=true
							}else{
								that.getPayProductList()
							}
						}
					}else{
						Message('您已领取过新手礼包-_- ');
					}
				})
			},
			// 关闭iframe
			closeIframe(){
				let that = this;
				// 取消蒙层
				that.RanksDialog = false
				that.isGameIframeShow=false
				// 恢复页面滚动
				document.querySelector('body').style.overflow = '';
				let dom = document.querySelector('#gameWindow');
				dom.remove();

				location.reload();
				// that.reloadMounted()
			},
			// 游戏内退出使用
			iframeGanmeOut(timer){
				let that = this;
				timer = timer?timer:2000;
				setTimeout(()=>{
					that.closeIframe();
					that.outGame();
					that.$refs['huanqvBtn'].$el.style.opacity = 1;
					that.$refs['huanqvBtn'].$el.style.pointerEvents  = '';
				},timer)
			},
			// 常玩游戏上报
			ReportingGames(gameID){
				let that = this;
				let url = 'api/v2/cloud_pc/app/game/game_add_often/'+that.userInfo.user_id+'/'+gameID + '?source=1';
				that.$req.get(url)
				.then(res=>{
					console.info(res)
					// if(res.Code === 0){
					// }
				})
				.catch(err=>{
					console.error(err);
				})
			},
			// 换区后的确认事件
			huanqvCommit(){
				let that = this;
				// that.pingShow = true;
				that.outGame();
			},
			//A游戏排队时 给出提示 确认后 切换至B游戏
			closeAfterOpenChange(){
				let that = this;
				sessionStorage.setItem('gameId',that.changeGame.ID)
				sessionStorage.setItem('gameName',that.changeGame.name)
				that.ReportingGames(that.changeGame.ID);
				document.querySelector('#gameWindow').contentWindow.sendLineShow();
				that.miniIframe('100%','100%');				
			},
			//关闭上一个连接 打开新的连接 下游戏 连接新的游戏
			closeAfterOpen(){
				let that = this;
				// that.openCloudGame(that.replayItem);
				let str = that.cloudGameHistoryRegion.app_link_ip;
				let ip = str.substr(0,str.indexOf(':'));
				// let ip = 'test-bky.cloudpc.cn';
				let url = 'wss://'+ip+':2235/msg';
				let data = {
					"cmd": "logout",		//cmd 命令
					"hostname": that.userInfo.user_id,	//通过后台登录可以获取
					"token": JSON.parse(localStorage['login']).token, 		//通过后台登录可以获取
					"is_cloud_game": true    //请求的是云电脑还是云游戏 true表示云游戏
				};
				let ws = new WebSocket(url);
				ws.onopen = function(){
					ws.send(JSON.stringify(data));
					setTimeout(()=>{
						ws.close();
					},500)
				}
				ws.onmessage = function(e){
					// console.info(e.data)
					let result = JSON.parse(e.data);
					if(result.code == 0||result.code == 1){
						if(document.querySelector('#gameWindow')){
							let obj = that.replayItem.Game?that.replayItem.Game.ID:that.replayItem.ID;
							that.ReportingGames(obj);
							document.querySelector('#gameWindow').contentWindow.sendLineShow();
							that.miniIframe('100%','100%')
						}else{
							that.openCloudGame();
						}
					}
				}				
			},
			closeAfterOpenGame(){
				let that = this;
				let str = JSON.parse(localStorage['region']).room_ip[0];
				let ip = str.substr(0,str.indexOf(':'));
				// let ip = 'test-bky.cloudpc.cn';
				let url = 'wss://'+ip+':2235/msg';
				let data = {
					"cmd": "logout",		//cmd 命令
					"hostname": that.userInfo.user_id,	//通过后台登录可以获取
					"token": JSON.parse(localStorage['login']).token, 		//通过后台登录可以获取
					"is_cloud_game": false    //请求的是云电脑还是云游戏 true表示云游戏
				};

				let ws = new WebSocket(url);
				ws.onopen = function(){
					ws.send(JSON.stringify(data));
					setTimeout(()=>{
						ws.close();
					},500)
				}
				ws.onmessage = function(e){
					console.info(e.data)
					let result = JSON.parse(e.data);
					if(result.code == 0||result.code == 1){
						if(document.querySelector('#gameWindow')){
							document.querySelector('#gameWindow').contentWindow.sendLineShow();
							that.miniIframe('100%','100%')
						}else{
							that.openCloudGame();
						}
					}
				}				
			},
			getPayProductList(){
				let that = this;
				let url = 'api/v1/cloud_pc/app/product/list';
				that.$req.post(url,{
					"product_type":2
				})
				.then(res=>{
					if(res.code == 0){
						let data=[]
						res.data.forEach((item)=>{
							if(item.id>=96&&item.id<=100){
								data.push(item)
							}
						})
						that.payProductList=data
						
						let afterTime=new Date().toLocaleDateString()
						// let beforeTime="2020-09-20"
						let beforeTime=that.userInfo.create_time.split(" ")[0]
						let day=that.daysBetween(afterTime,beforeTime)

						let payId
						if(day==0){
							payId=96
						}else if(day==1){
							payId=97
						}else if(day==2){
							payId=98
						}else if(day==3){
							payId=99
						}else if(day==4){
							payId=100
						}

						
						that.payProductList.forEach((item)=>{
							if(payId==item.id){
								that.payProductActiveOrder=item
								return 
							}
						})

						if(JSON.stringify(that.payProductActiveOrder)=="{}"){
							localStorage.removeItem("miniActive") 
							return 
						}

						that.countDownNum=""
						if(day>=0){
							that.activeCountDown()
							if(day==0){
								that.haoli1Show=true
							}else if(day>0&&day<=4){
								that.haoli2Show=true
							}
							localStorage.setItem("miniActive",false)
						}

					}
				})
			},
			timestampGetDay(after,before){
				let nowTimestamp
				if(after==null){
					nowTimestamp=new Date().getTime()
				}else{
					nowTimestamp=new Date(after).getTime()
				}
				let createimestamp=new Date(before).getTime()
				return Math.floor((nowTimestamp-createimestamp)/86400000)
			},
			daysBetween(DateOne,DateTwo){
				var OneMonth = DateOne.substring(5,DateOne.lastIndexOf ('/'));  
				var OneDay = DateOne.substring(DateOne.length,DateOne.lastIndexOf ('/')+1);  
				var OneYear = DateOne.substring(0,DateOne.indexOf ('/'));  
			
				var TwoMonth = DateTwo.substring(5,DateTwo.lastIndexOf ('-'));  
				var TwoDay = DateTwo.substring(DateTwo.length,DateTwo.lastIndexOf ('-')+1);  
				var TwoYear = DateTwo.substring(0,DateTwo.indexOf ('-'));  
			
				var cha=((Date.parse(OneMonth+'/'+OneDay+'/'+OneYear)- Date.parse(TwoMonth+'/'+TwoDay+'/'+TwoYear))/86400000);   
				return Math.abs(cha);  
			},
			activeCountDown(){
				let that=this
				let now
				let lingcheng=new Date().toLocaleDateString().split("/").join("-")+" 24:00:00"
				clearInterval(that.countDownTimer)
				that.countDownTimer=null
				that.countDownTimer=setInterval(()=>{
					now=new Date().getTime()
					let total =(new Date(lingcheng).getTime()-now)/1000
					that.countDownNum=that.formatSeconds(total)
				},1000)
			},
			formatSeconds(result){
				var h = Math.floor(result / 3600) < 10 ? '0'+Math.floor(result / 3600) : Math.floor(result / 3600);
				var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
				var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
				return result = h + ":" + m + ":" + s;
			},
			handleHaoLiClose(){
				let that=this
				that.haoli1Show=false
				that.haoli2Show=false
				clearInterval(that.countDownTimer)
				that.countDownTimer=null
				that.miniActiveShow=true
				localStorage.setItem("miniActive",true)
			},
			handleHaoliPay(payid){
				let that=this
				let payId
				that.haoli1Show=false
				that.haoli2Show=false
				that.haoliPayShow=true

				if(payid){
					payId=payid
					that.payProductList.forEach((item)=>{
						if(payId==item.id){
							that.payProductActiveOrder=item
							return 
						}
					})
				}
				that.getHaoliQRcode()
			},
			handleHaoLiPayClose(){
				let that=this
				that.haoliPayShow=false
				that.miniActiveShow=true
				localStorage.setItem("miniActive",true)
			},
			selectHaoliPayType(name){
				let that=this
				that.haoliPayType=name
				that.getHaoliQRcode()
			},
			//  更新豪礼付款码
			getHaoliQRcode() {
				let that = this;
				let url = 'api/v1/cloud_pc/app/pay';
				let data = {
					"terminal": "WEB", // 终端来源 Android/IOS/PC/WEB
					"channel": that.haoliPayType, //支付渠道  alipay、wxpay、paypal(暂不支付)
					"method": "qr_code", //web(PC 浏览器)、wap（手机浏览器(支付宝))、app(生成支付参数，用于 App 上调用相关的 SDK 使用(支付宝、微信支付))、qr_code(生成收款二维码，供用户扫码进行支付(支付宝、微信支付))、f2f(扫描用户的付款码进行收款)
					"product_id": that.payProductActiveOrder.id, // 商品id,自定义金额时id为0
				};
				// if(that.Paymen == 'wxpay'){
				// 	url = 'api/v1/cloud_pc/app/pay3';
				// }
				that.qr_text = '';
				that.$req.post(url,data)
					.then(res => {
						// console.info(res);
						if (res.code === 0 && res.data) {
							// let ele = that.Paymen == 'alipay' ? 'qrcode' : 'qrcode2';
							that.qr_text = res.data.url;
							// 轮询支付状态
							if (that.haoliPayTimer != null || that.haoliPayTimer) {
								clearInterval(that.haoliPayTimer);
							}
							that.haoliPayTimer = setInterval(() => {
								let query = {
									"channel": that.haoliPayType,
									"trade_no": "",
									"out_trade_no": res.data.order_no
								};
								that.getHaoliPayStatus(query);
							}, 3000)
			
						} else {
							Message.error(res.msg);
						}
					})
					.catch(err => {
						console.error(err);
					})
			},
			// 获取豪礼支付回调
			getHaoliPayStatus(data) {
				let that = this;
				let url = 'api/v1/cloud_pc/app/pay/query';
				that.$req.post(url,data)
					.then(res => {
						// console.info(res);
						if (res.code === 0 && res.data) {
							that.$utils.Burying({
								act: 'zhifuSuccess',
								user_attribute: 'old',
								userID: JSON.parse(localStorage['login']).user_id,
								phone: that.userInfo.phone,
								operating_system: 'web',
								Registration_time: that.userInfo.create_time,
								Purchase_quantity:1,
							});
							// 充值成功后 重新获取用户信息
							that.$bus.$emit('getLogin');
							that.getLoginInfo();
							that.miniActiveShow=false
							that.haoli1Show=false
							that.haoli2Show=false
							that.haoliPayShow=false
							Message.success("充值成功")
							localStorage.removeItem("miniActive")
							clearInterval(that.haoliPayTimer);
						}
					})
					.catch(err => {
						console.error(err);
					})
			},
			handleMiniActive(){
				let that=this
				that.miniActiveShow=false
				that.getPayProductList()
			},
			JumpToGame(){
				let that=this
				that.$router.push('/game.html');
				that.$bus.$emit('geme',2);
			},
			handleVideoplay(index){
				document.getElementById("swiperVideo"+index).getElementsByTagName("video")[0].play()
			},
			onPlayerPlay(index){
				document.getElementById("swiperVideoPlayIcon"+index).style.display="none"
			},
			onPlayerPause(index){
				document.getElementById("swiperVideoPlayIcon"+index).style.display="block"
			}
		}
	}
</script>
<style lang="less">
@import "../style/haoli.less";
.frameDiv{
	position: fixed;
    // width: 100%;
    // height: 100%;
	z-index: 2001;
	// top:0;
	.gameWindow{
		display: flex;
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		overflow: auto;
		margin: 0 auto;
		z-index: 100000;
		border-width: 0;
		border:none
	}
	.gameWindowMini{
		display: flex;
		position: fixed;
		top: 50vh;
		right: 0;
		bottom: 0;
		overflow: auto;
		z-index: 100000;
		border-width: 0;
	}
}
</style>
<style lang="less" scoped>
	// .is-disabled{
	// 	cursor: not-allowed !important;
	// }
	//蒙版
	button{
		outline: none;
	}
	.modalDiv{
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		overflow: hidden;
		margin: 0;
		background-color: rgba(121,121,121,.4);
		z-index: 999;
	}
	.gameDetail{
		min-width: 1600px;
		margin-top: -15px;
		.contain{
			// max-width: 100%;
			background:url(../assets/gameDetail/bg.png) no-repeat;
			padding-bottom: 50px;
			background-color: #000;
			width: 100%;
			background-size: 100% 100%;
		}
		.detail-banner{
			width: 100%;
			height: 300px;
			overflow: hidden;
			// background-color: #000;
			position: relative;
			.banner-img{
				position: absolute;
				top:50%;
				transform:translateY(-50%);
				width: 100%;
				img{
					height: auto;
					min-height:300px;
				}
				/deep/
				.el-image__inner{
					height: auto;
					min-height:300px;
					top: 0;
					left: 0;
					transform: translate(0,0);
					-webkit-transform: translate(0,0);
				}
			}
			.el-image{
				overflow:initial;
			}
			.masking-black{
				width: 100%;
				height: 100%;
				position: absolute;
				top:0;
				left: 0;
				background-color: rgba(0,0,0,0.7);
			}
			.banner-game-part{
				position: absolute;
				left: 50%;
				margin-top:130px;
				transform: translate(-50%,0);
				display: flex;
				justify-content: space-between;
				align-items: center;
				width: 1200px;
				.game-part-left{
					display: flex;
					align-items: center;
					.game-logo{
						width: 120px;
						height: 120px;
						border-radius: 10px;
					}
					.left-detail{
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						color:#fff;
						margin-left: 30px;
						height: 100px;
						h3{
							font-size: 24px;
							line-height: 31px;
							margin:0;
						}
						p{
							margin:0;
							font-size: 14px;
							max-width: 600px;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							overflow: hidden;
							opacity: 0.8;
						}
						.tag-group{
							display: flex;
							span{
								border:1px solid #F9DD4A;
								border-radius: 4px;
								padding: 4px 17px;
								font-size: 12px;
								color:#F9DD4A;
								margin-right: 6px;
							}
						}
					}
				}
				.right-btn-group{
					display: flex;
					flex-direction: row-reverse;
					height: 120px;
					align-items: center;
					button{
						outline: none;
						border:none;
						padding: 0;
						width:200px;
						height:50px;
						border-radius:4px;
						font-size: 18px;
						font-weight: bold;
						outline: none;
						border:none;
						display: flex;
						align-items: center;
						justify-content: center;
						cursor: pointer;
					}
					button:active{
						transform:translate(0,5px);
						-webkit-transform:translate(0,5px)
					}
					.play-game{
						background-color: #F9DD4A;
						color:#000;
						img{
								width: 22px;
								margin-right: 5px;
						}
					}
					.again-game{
						background: linear-gradient(90deg, #0063FD 0%, #00B3FF 100%);
						color: #fff;
					}
					.close-game{
						width: 120px;
						margin-right: 20px;
						color: #fff;
						border-radius: 4px;
						border: 1px solid rgba(255,255,255,0.4);
						background-color: transparent;
					}
				}
			}
		}
		.game-detail-content{
			margin:10px auto 0;
			width: 1200px;
			display: flex;
			justify-content: space-between;
			padding-bottom: 73px;
			position: relative;
			.content-left{
				width: 840px;
			}
			.content-right{
				width: 340px;
				background-color: #2A3039;
				.des-img{
					width: 340px;
					height: 160px;
				}
				.des-content{
					margin:26px 29px 0;
					h5{
						font-size: 16px;
						margin:0;
						font-weight:bold;
						padding-bottom:14px;
						border-bottom:1px solid #FFFFFF;
						display: inline-block;
						color:#FFFFFF;
					}
					p{
						font-size: 14px;
						color:#838D9A;
						line-height: 24px;
						margin: 0;
						border-top: 1px solid #383C45;
						padding: 20px 0;
						margin-top:-1px;
					}
					button{
						display: block;
						width:240px;
						height:54px;
						border-radius:27px;
						line-height: 54px;
						font-size: 14px;
						margin:40px auto 50px;
						cursor: pointer;
						border:none;
						outline: none;
					}
				}
			}
			.content-left{
				.detail-carousel{
					width: 840px;
					height: 460px;
					//  .swiper-wrapper{
					.swiper-slide{
						width: 840px;
						height: 460px;
						background-size: 100% 100%;
					}
					// }
					/deep/.el-carousel__indicators{
						display: none;
					}
					/deep/.el-carousel__arrow{
						display: none;
					}
				}
				.detail-swiper{
					.swiper-wrapper{
						.swiper-slide{
							width: 840px;
							height: 460px;
							background-size: 100% 100%;
							overflow: hidden;
							img{
								width: 840px;
								height: 460px;
							}
							.play-big{
								width: 80px;
								height: 80px;
								left: 50%;
								top:50%;
								position: absolute;
								width: 80px;
								height: 80px;
								background: url("../assets/gameDetail/play-big.png") no-repeat 100% 100%;
								background-size: 100% 100%;
								transform: translate(-50%,-50%);
								-webkit-transform: translate(-50%,-50%);
								cursor: pointer;
								border:none
							}
							.play-big:hover{
								background: url("../assets/gameDetail/play-hover.png") no-repeat 100% 100%;
							}
							.video-player{
								/deep/.vjs-big-play-button{
									display: none;
								}
								/deep/.vjs-tech{
									object-fit:fill;
								}
							}
						}
					}
					.swiper-button-prev,.swiper-button-next{
						background-color: rgba(255,255,255,0.2);
						// border-radius: 3px;
						padding: 5px 5px;
						outline: none;
						// background-color: #f9dd4a;
						display: none;
					}
					.swiper-button-prev:after,.swiper-button-next:after{
						// color:#f9dd4a;
						// content:"";
						display: none;
					}
					.swiper-button-prev{
						left: 0;
					}	
					.swiper-button-next{
						right: 0;
					}
					.swiper-button-prev img,.swiper-button-next img{
						width: 10px;
					}
					.swiper-button-prev:hover,.swiper-button-next:hover{
						background-color: #f9dd4a;
					}
				}
				.detail-swiper:hover{
					.swiper-button-prev,.swiper-button-next{
						// background-color: #f9dd4a;
						display: flex;
					}
				}
				.detail-swiper-thumbs{
					margin-top:7px;
					.swiper-wrapper{
						.swiper-slide{
							height: 90px;
							cursor: pointer;
							img{
								width: 100%;
								height: 90px;
							}
							.masking-swiper{
								position: absolute;
								width: 100%;
								height: 100%;
								background-color: rgba(0,0,0,0.5);
								z-index: 2;
							}
							.play-small{
								position: absolute;
								width: 40px;
								height: 40px;
								top:50%;
								left: 50%;
								transform: translate(-50%,-50%);
								-webkit-transform: translate(-50%,-50%);
							}
						}
						.swiper-slide-thumb-active{
							.masking-swiper{
								display: none;
							}
						}         
					}
				}
			}
		}
		.game-nav-part{
			margin: 30px auto 0px;
			width: 1200px;
			font-size: 14px;
			// color: #0D0D0D;
			color:#C7CDD5;
			.jump-game:hover{
				text-decoration: underline;
			}
		}
		
		// 新手礼包样式
		.NoviceGift{
			// display: none;
			top: 25vh;
			width: 515px;
			height: 325px;
			margin: 0 auto;
			text-align: center;
			position: relative;
			background: url(../assets/gameDetail/xinshoulibao.png) no-repeat left top;
			background-size: 100%;
			.lingqv{
				width: 160px;
				height: 45px;
				vertical-align: middle;
				position: relative;
				bottom: -80%;
				left: 10%;
				cursor: pointer;
			}
		}
		
		.ellipsis-more{
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 5;
			overflow: hidden;
		}
		.foot .footText{
			width: 80%;
		}
	}

	// 加载
	.fullLoadingClass{
		top: 50%;
		margin-top: -21px;
		width: 100%;
		text-align: center;
		position: absolute;
		/deep/
		.el-loading-spinner .path{
			stroke:#F9DD4A !important;
			stroke-width:4 !important;
			color: #F9DD4A;
		}
		/deep/
		.el-loading-spinner .el-loading-text{
			color: #fff;
			font-size: 14px;
			margin: 3px 0px;
		}
	}
	// 新手礼包样式
	.NoviceGift{
		// display: none;
		top: 25vh;
		width: 515px;
		height: 325px;
		margin: 0 auto;
		text-align: center;
		position: relative;
		background: url(../assets/game/xinshoulibao.png) no-repeat left top;
		background-size: 100%;
		.lingqv{
			width: 160px;
			height: 45px;
			vertical-align: middle;
			position: relative;
			bottom: -80%;
			left: 10%;
			cursor: pointer;
		}
	}
	.mini-active{
		top:0
	}
</style>
